var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { mortgageData, templates } = options;  
__p+='\n<li>\n  <i class="ra ra-circle legend-hoa icon-space-right"></i>\n  <span id=\'hoa-title-text\'>\n    HOA Fees\n  </span>\n  <div class="float-right editinplace-trigger display-inline">\n    <input type="text" value="'+
((__t=( mortgageData.hoa ))==null?'':__t)+
'" class="input-no-style input-edit-inplace payment_option_fields" id="hoa_fees" maxlength="8" size="8"/>\n  </div>\n</li>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/legend/hoa.jst.ejs